export const CLICKED_CONTINUE_IN_DESKING = 'CLICKED_CONTINUE_IN_DESKING';
export const CLICKED_CONTINUE_IN_UNIFI = 'CLICKED_CONTINUE_IN_UNIFI';
export const CLICKED_COPY_DEAL_URL = 'CLICKED_COPY_DEAL_URL';
export const CLICKED_COPY_DEAL_URL_CLICKED = 'CLICKED_COPY_DEAL_URL_CLICKED';
export const CLICKED_SEND_TO_ECOMMERCE = 'CLICKED_SEND_TO_ECOMMERCE';
export const CLICKED_PUSH_TO_DMS_CONFIRM = 'CLICKED_PUSH_TO_DMS_CONFIRM';
export const CLICKED_BEGIN_CHECKOUT = 'CLICKED_BEGIN_CHECKOUT';
export const CLICKED_CONTINUE_IN_DESKING_CONFIRM = 'CLICKED_CONTINUE_IN_DESKING_CONFIRM';
export const SEND_TO_SALES_VIEW_CONFIRM = 'SEND_TO_SALES_VIEW_CONFIRM';
export const CLICKED_SEND_TO_CUSTOMER = 'CLICKED_SEND_TO_CUSTOMER';
export const CONTINUE_IN_DESKING = 'CONTINUE_IN_DESKING';
export const PAYMENT_FAILURE = 'PAYMENT_FAILURE';
export const PAYMENT_RECEIVED = 'PAYMENT_RECEIVED';
export const PAYMENT_REQUESTED = 'PAYMENT_REQUESTED';
export const SHOW_TOTAL_TAX_RATE_SUPERSEDE_ALERT = 'SHOW_TOTAL_TAX_RATE_SUPERSEDE_ALERT';
export const HIDE_TOTAL_TAX_RATE_SUPERSEDE_ALERT = 'HIDE_TOTAL_TAX_RATE_SUPERSEDE_ALERT';
export const SET_FORCE_RELOAD_ON_WS_EVENT_TRIGGERED = 'SET_FORCE_RELOAD_ON_WS_EVENT_TRIGGERED';
export const UPDATE_QUALIFICATION_IDS = 'UPDATE_QUALIFICATION_IDS';

// AI Lender Probability Action Types
export const AI_LENDER_PROBABILITY_REQUEST = 'AI_LENDER_PROBABILITY_REQUEST';
export const AI_LENDER_PROBABILITY_SUCCESS = 'AI_LENDER_PROBABILITY_SUCCESS';
export const AI_LENDER_PROBABILITY_FAILURE = 'AI_LENDER_PROBABILITY_FAILURE';

// AI Vehicle Recommendation Action Types
export const AI_VEHICLE_RECOMMENDATIONS_REQUEST = 'AI_VEHICLE_RECOMMENDATIONS_REQUEST';
export const AI_VEHICLE_RECOMMENDATIONS_SUCCESS = 'AI_VEHICLE_RECOMMENDATIONS_SUCCESS';
export const AI_VEHICLE_RECOMMENDATIONS_FAILURE = 'AI_VEHICLE_RECOMMENDATIONS_FAILURE';
export const UPDATE_VEHICLE_WITH_SELECTED_RECOMMENDATION = 'UPDATE_VEHICLE_WITH_SELECTED_RECOMMENDATION';
export const APPLY_RECOMMENDED_VEHICLE_PAYMENT_DETAILS = 'APPLY_RECOMMENDED_VEHICLE_PAYMENT_DETAILS';

// AI Refresh Button Action Types
export const SHOW_AI_REFRESH_BUTTON = 'SHOW_AI_REFRESH_BUTTON';
export const HIDE_AI_REFRESH_BUTTON = 'HIDE_AI_REFRESH_BUTTON';
export const TRIGGER_AI_REFRESH = 'TRIGGER_AI_REFRESH';

// AI Analytics Action Types (CDL3 Desking Intelligence)
export const AI_REFRESH_CLICKED = 'AI_REFRESH_CLICKED'; // dc-mv-260
export const VEHICLE_RECOMMENDATION_DISPLAYED = 'VEHICLE_RECOMMENDATION_DISPLAYED'; // dc-mv-261
export const VEHICLE_RECOMMENDATION_SELECTED = 'VEHICLE_RECOMMENDATION_SELECTED'; // dc-mv-285
export const SOFTPULL_CONSENT_CONTINUE_CLICKED = 'SOFTPULL_CONSENT_CONTINUE_CLICKED'; // dc-mv-277
export const SOFTPULL_CONSENT_CANCEL_CLICKED = 'SOFTPULL_CONSENT_CANCEL_CLICKED'; // dc-mv-283
export const LENDER_PROBABILITY_DISPLAYED = 'LENDER_PROBABILITY_DISPLAYED'; // dc-mv-278
export const LENDER_RETURN_TO_OFFER_CLICKED = 'LENDER_RETURN_TO_OFFER_CLICKED'; // dc-mv-279
export const LENDER_BACKEND_LIMIT_DETAILS_CLICKED = 'LENDER_BACKEND_LIMIT_DETAILS_CLICKED'; // dc-mv-321
export const SOFTPULL_ALT_CONSENT_CONTINUE_CLICKED = 'SOFTPULL_ALT_CONSENT_CONTINUE_CLICKED'; // dc-mv-281
export const SOFTPULL_MANDATORY_DETAILS_CONTINUE_CLICKED = 'SOFTPULL_MANDATORY_DETAILS_CONTINUE_CLICKED'; // dc-mv-300

// AI Alternative Deal Structure Analytics (CDL3)
export const ALT_DEAL_STRUCTURE_LINK_CLICKED = 'ALT_DEAL_STRUCTURE_LINK_CLICKED'; // dc-mv-288
export const ALT_DEAL_STRUCTURE_OPTIONS_VIEWED = 'ALT_DEAL_STRUCTURE_OPTIONS_VIEWED'; // dc-mv-289
export const ALT_DEAL_STRUCTURE_CREATE_SCENARIO_CLICKED = 'ALT_DEAL_STRUCTURE_CREATE_SCENARIO_CLICKED'; // dc-mv-290
export const ALT_DEAL_STRUCTURE_CANCEL_CLICKED = 'ALT_DEAL_STRUCTURE_CANCEL_CLICKED'; // dc-mv-291
export const ALT_DEAL_STRUCTURE_TERM_DOWN_PAYMENT_UPDATED = 'ALT_DEAL_STRUCTURE_TERM_DOWN_PAYMENT_UPDATED'; // dc-mv-292
export const ALT_DEAL_STRUCTURE_RETRY_RATES_CLICKED = 'ALT_DEAL_STRUCTURE_RETRY_RATES_CLICKED'; // dc-mv-296
